/**
 * Enum for tabindex attribute values.
 */
export enum TabIndex {
  Enabled = '0',
  Disabled = '-1',
}
